<template>
    <div class="pipe-diameter-analysis">
        <div style="color: #fff;height: 30px;">泵站信息</div>
        <div v-for="item in pumpList" :key="item.id" class="pump-item">
            <div class="pump-name">
                <div>名称</div>
                <div>{{ item.name }}</div>
            </div>
            <div class="pump-scale">
                <div style="font-size: 12px;">规模(万吨/日)</div>
                <div style="color: #299ac3">{{ item.scale }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { pumpList } from "@/views/pipe-info/api/pipe-info";
export default {
    name: "pipe-diameter-analysis",
    data() {
        return {
            pumpList: []
        };
    },
    mounted() {
        this.getPumpList();
        this.startScrolling();
    },
    methods: {
        getPumpList() {
            pumpList({ pageNum: 1, pageSize: 100 }).then(res => {
                console.log("res:", res);
                this.pumpList = res.list;
            });
        },
        startScrolling() {
            setInterval(() => {
                if (this.pumpList.length > 1) {
                    const firstItem = this.pumpList.shift();
                    this.pumpList.push(firstItem);
                }
            }, 1000); // 每秒移动一次
        }
    }
};
</script>

<style scoped>
.pipe-diameter-analysis {
    width: 48%;
    height: 23vh;
    overflow: hidden;
}
.pump-item {
    width: 100%;
    color: #adadad;
    margin: 0.2rem 0;
}
.pump-name {
    display: flex;
    justify-content: space-between;
}
.pump-scale {
    display: flex;
    justify-content: space-between;
}
</style>